export default __webpack_public_path__ + "static/media/smallfish.c0f95a5d.jpg";